import React from "react";
import { Phone, Mail, Globe, MapPin } from "lucide-react";
import { useI18n } from "@/i18n";
import { contactInfo, vhrpImages } from "@/lib/site";

export default function Contact() {
  const { t } = useI18n();

  const rows = [
    { icon: Phone, label: t("contactCallLabel"), value: `${contactInfo.landline} · ${contactInfo.hours}`, href: contactInfo.landlineHref },
    { icon: Mail, label: t("contactEmailLabel"), value: contactInfo.email, href: contactInfo.emailHref },
    { icon: Globe, label: t("contactWebsiteLabel"), value: contactInfo.website, href: contactInfo.websiteHref },
    { icon: MapPin, label: t("contactAddressLabel"), value: contactInfo.address, href: contactInfo.addressHref },
  ];

  return (
    <div className="mx-auto max-w-4xl px-4 py-14">
      <div className="flex items-center gap-4">
        <img src={vhrpImages.logoMark} alt="" className="h-16 w-16 rounded-full ring-2 ring-brand-tint" />
        <div>
          <h1 className="text-3xl font-black text-ink">{t("contactTitle")}</h1>
          <p className="mt-1 text-ink-muted">{t("contactIntro")}</p>
        </div>
      </div>

      <div className="mt-8 grid gap-4 sm:grid-cols-2">
        {rows.map((r, i) => (
          <a
            key={r.label}
            href={r.href}
            target={r.href.startsWith("http") ? "_blank" : undefined}
            rel="noreferrer"
            data-testid={`contact-${r.label}`}
            className="flex items-start gap-4 rounded-2xl border border-line bg-white p-5 transition-all hover:-translate-y-0.5 hover:border-brand hover:shadow-md"
          >
            <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-brand-tint text-brand">
              <r.icon size={20} />
            </span>
            <div className="min-w-0">
              <div className="text-xs font-bold uppercase tracking-wide text-ink-muted">{r.label}</div>
              <div className="mt-0.5 break-words font-semibold text-ink">{r.value}</div>
            </div>
          </a>
        ))}
      </div>

      <div className="mt-6 overflow-hidden rounded-2xl border border-line">
        <iframe
          title="VHRP Head Office"
          className="h-72 w-full"
          loading="lazy"
          src="https://maps.google.com/maps?q=Gomti+Nagar+Lucknow+226010&output=embed"
        />
      </div>
    </div>
  );
}
